import { Stack, StackProps, styled } from '@mui/material';
import { generateClasses } from '../../utils/helper';

export const restrictedPageClasses = generateClasses('RestrictedPage', ['description']);

export const Root = styled((props: StackProps) => <Stack height="100%" {...props} />)(({ theme }) => ({
  color: theme.palette.common.white,
  background: `linear-gradient(0deg, ${theme.palette.grey[900]} 0%, ${theme.palette.primary[900]} 100%)`,
  position: 'relative',

  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    backgroundImage: `url(${require('../../../../assets/restricted-page-bg.png')})`,
    backgroundPosition: 'top 0 left 0',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    pointerEvents: 'none',
  },

  [`& .${restrictedPageClasses.description}`]: {
    flex: 1,
  },
}));

export const List = styled('ul')(({ theme }) => ({
  margin: theme.spacing(4, 0),
  paddingLeft: theme.spacing(6.5),
  '& li': {
    lineHeight: 1,
  },
}));
